import { Button } from 'antd';
import styled from 'styled-components';

export const ApplicationReviewsStyled = styled.div`
	scrollbar-width: none;
	-ms-overflow-style: none;
	gap: 16px;
	display: flex;
	flex: 1;
	overflow-x: scroll;
	overflow-y: hidden;
	&::-webkit-scrollbar {
		display: none;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		overflow-x: hidden;
		gap: 24px;
	}
`;

export const BackButton = styled(Button)`
	position: absolute;
	top: 50%;
	left: -20px;
	display: none;
	filter: drop-shadow(0px 3px 8px rgba(93, 95, 97, 0.1));
	transform: translateY(-50%);

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}
`;

export const ForwardButton = styled(Button)`
	position: absolute;
	top: 50%;
	right: -20px;
	display: none;
	filter: drop-shadow(0px 3px 8px rgba(93, 95, 97, 0.1));
	transform: translateY(-50%);
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}
`;
